const initialState = {
	options: {
		0: 'Domains',
		1: 'Technik',
		2: 'Hosting',
		3: 'Kunden',
		4: 'Budget',
	},
	paths : {
		0: '/items',
		1: '/technical',
		2: '/hosting',
		3: '/clients',
		4: '/budget',
	}
};

export const startpages = {
	namespaced: true,
	state: initialState,
	actions: {},
	mutations: {},
};
